import React from 'react'

const HomePage = React.lazy(() => import('../pages/HomePage'))
const Products = React.lazy(() => import('../pages/Products'))
const LoanCalculate = React.lazy(() => import('../pages/LoanCalculate'))

export { HomePage, Products, LoanCalculate }
